module.exports = __webpack_public_path__ + "img/art-54.2882f037.png";